// @ts-check
import React from 'react';

import Box from '@liquidweb-dev/undercurrent/Box';

/** @param {import('@liquidweb-dev/undercurrent/Box').BoxProps} props */
const ActionsContainer = (props) => {
	return (
		<Box
			sx={{
				display: 'flex',
				gap: 100,
				alignItems: 'center',
				justifyContent: 'flex-end',
			}}
			{...props}
		/>
	);
};

export default ActionsContainer;
